import React, { useEffect } from 'react';
import App from 'src/App';
import { log } from 'src/services/LogService';
import { wrap } from './wrap';
import { appWrapperProperties } from './appWrapperProperties.ts';

const AppWrapper: React.FC = (props) => {
  const [className] = React.useState(() => 'AppWrapper-' + Date.now());
  useEffect(() => {
    log.info(className, 'MSG001', '-- AppWrapper Init --');
  }, []);

  const allProps = { ...props, ...appWrapperProperties };
  return <App {...allProps} />;
};

const WrappedAppWrapper = wrap(AppWrapper);
export default WrappedAppWrapper;
